import useTranslation from "../../../../hooks/i18n/useTranslation";
import "../../styles/Settings.css";

export const SettingsRow = ({ labelKey, children, className = "", id }) => {
    const { t } = useTranslation();

    return (
        <div className={`settings-container-regional-item ${className}`}>
            <label className="settings-label" htmlFor={`settings-row-${id}`}>
                {t(labelKey)}
            </label>
            {children}
        </div>
    )
}   